export default class DateUtil {
    /**
     * @function date2Str Convert a date object to a string
     *
     * @param value {int} value number of milliseconds since January 1, 1970, 00:00:00 UTC
     * @param useLocalTimeZone {boolean} useLocalTimeZone if should use local timezone, or UTC if false
     *
     * @return a result object containing the Date Object and a errorMsg if there was a problem converting it
     */
    date2Str(value: number, useLocalTimeZone: boolean): string {
        const date = new Date(value);
        if (!useLocalTimeZone) {
            return date.toISOString();
        }
        
        let str = (date.getYear() + 1900);
        str += '-';
        str += this.twoDigitsStr(date.getMonth() + 1);
        str += '-';
        str += this.twoDigitsStr(date.getDate());
        str += 'T';
        str += this.twoDigitsStr(date.getHours());
        str += ':';
        str += this.twoDigitsStr(date.getMinutes());
        str += ':';
        str += this.twoDigitsStr(date.getSeconds());
        str += '.';
        str += this.threeDigitsStr(date.getMilliseconds());
        str += 'T'; // toISOString sets Z... using T to specify it's using Timezone
        
        return str;
    }

    /**
     * 
     * @param n 
     * 
     * @returns 
     */
    private twoDigitsStr(n: number): string {
        if (n >= 10) {
            return n + '';
        }
        
        return '0' + n;
    }

    /**
     * 
     * @param n 
     * 
     * @returns 
     */
    private threeDigitsStr(n: number): string {
        if (n >= 100) {
            return n + '';
        }
        
        if (n >= 10) {
            return '0' + n;
        }
        
        return '00' + n;
    }    

    /**
     * 
     * @param value 
     * @param useLocalTimeZone 
     * 
     * @returns 
     */
    dateToISO8601Str(value: number, useLocalTimeZone: boolean) {
        return this.date2Str(value, useLocalTimeZone).replace(/.$/,"Z");
    }

    /**
     * convert to "YYYY-MM-DD hh:mm" (using local time)
     * 
     * @param date
     * @returns
     */
    dateToCalendarStr(date: number): string {
        return this.date2Str(date, true).substring(0,16).replace('T', ' ');
    }

    /**
     * Human-readable string representation of seconds
     * 
     * @param numberOfSeconds (integer) seconds
     *
     * @return (string) text formatted indicating number of seconds
    */
    secondsToText(numberOfSeconds): string {
        if (numberOfSeconds < 60) {
            return numberOfSeconds + ' sec'
        }
        
        const sec_num = parseInt(numberOfSeconds, 10); // don't forget the second param
        const days   = Math.floor(sec_num / 86400);
        const hours = Math.floor((sec_num - (days * 86400)) / 3600);
        const minutes = Math.floor((sec_num - (days * 86400) - (hours * 3600)) / 60);

        let dateText = "";
        dateText += days ? days === 1 ? days + " day " : days + " days " : "";
        dateText += hours ? hours === 1 ? hours + " hour " : hours + " hours " : "";
        dateText += minutes ? minutes === 1 ? minutes + " min " : minutes + " mins " : "";

        return dateText;
    }

    /**
     * This method returns the specific date format to use with Datepicker for the current
     * user setting DateFormat
     * @param userSettingDateFormat
     * @returns {string}
     */
    datepickerCalendarDateFormat(userSettingDateFormat: string) {
        let result;
        switch (userSettingDateFormat) {
            case 'dd/MM/yyyy':
                result = 'dd/mm/yy';
                break;
            case 'MM/dd/yyyy':
                result = 'mm/dd/yy';
                break;
            case 'yyyy-MM-dd':
                result = 'yy-mm-dd';
                break;
            case 'dd MMMM yyyy':
                result = 'dd MM yy';
                break;
            case 'MMMM dd, yyyy':
                result = 'MM dd, yy';
                break;
            default:
                throw new Error("Unsupported date format");

        }

        return result;
    }

    /**
     * Convert text representing time interval to timestamp in past since now.
     *
     * @param timestampText text value "all" or "6months" or "7Days" or "24Hours"
     * 
     * @returns
     */
    textTimeIntervalToMillisecondsTimestamp(timestampText: string): number {
        let lastTimestamp = 0;
        const oneDayMillis = 24 * 60 * 60 * 1000;
        switch(timestampText) {
            case "all" :
                lastTimestamp = 0;
                break;
            case "6Months" :
                const sixMontsMilis = 6 * 30 * oneDayMillis;
                lastTimestamp = Date.now() - sixMontsMilis;
                break;
            case "7Days" :
                const sevenDays = 7 * oneDayMillis;
                lastTimestamp = Date.now() - sevenDays;
                break;
            case "24Hours" :
                lastTimestamp = Date.now() - oneDayMillis;
                break;
            default:
                lastTimestamp = 0;
        }

        return lastTimestamp;
    }

    /**
     * Default value to use on first page load where is requested filtering only last used data
     * @returns {string}
     */
    textTimeIntervalDefaultValue(): string {
        return "6Months";
        //return "24Hours";
    }
}
